import { render } from "./UserFlattenAutocomplete.vue?vue&type=template&id=1b03cc50&ts=true"
import script from "./UserFlattenAutocomplete.vue?vue&type=script&lang=ts"
export * from "./UserFlattenAutocomplete.vue?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__